import { render } from "./optionItem.vue?vue&type=template&id=65e19929&scoped=true"
import script from "./optionItem.vue?vue&type=script&lang=js"
export * from "./optionItem.vue?vue&type=script&lang=js"

import "./optionItem.vue?vue&type=style&index=0&id=65e19929&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e19929"]])

export default __exports__